import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import {
  API_URL, FILE_STORAGE
} from '../../../../constants'

// Components
import Dropzone from '../../../components/Dropzone'
import Gallery from '../../../components/Gallery'
import Portal from '../../../components/Portal'
import Confirm from '../../../components/Confirm'

// Actions
import { createFileContainer, uploadMultipleFiles, uploadImageMarkings } from '../../../../actions/orders'

// Utils
import { translation } from '../../../../utils/helpers'
import RemoveButton from '../../../elements/removeButton'

class FileArea extends Component {
  constructor (props) {
    super(props)

    this.state = {
      upload: {
        errors: []
      },
      confirm: false
    }

    this.ensureFileContainer = this.ensureFileContainer.bind(this)
    this.onDrop = this.onDrop.bind(this)
    this.onDropAccepted = this.onDropAccepted.bind(this)
    this.onDropRejected = this.onDropRejected.bind(this)
  }

  ensureFileContainer () {
    if (this.props.fileContainerId === null) {
      return this.props.createFileContainer().then((res) => {
        this.props.updateState({
          fileContainerId: res.data.FileContainerId
        })
      })
    } else {
      return Promise.resolve()
    }
  }

  onDrop () {
    this.setState({ upload: { ...this.state.upload, errors: [] } })
  }

  onDropAccepted (files) {
    let documents = [...this.props.files]
    let images = [...this.props.images]

    this.ensureFileContainer().then(() => {
      this.props.uploadMultipleFiles(files, 0, undefined, undefined, this.props.fileContainerId).then((fileResponse) => {
        let uploadedFiles = fileResponse.data
        uploadedFiles.forEach((file, index) => {
          if (file.IsImage) {
            images.push({
              imageUrl: FILE_STORAGE + '/OrderFiles/' + file.RealFileURL,
              ImageSize: {
                Width: 0,
                Height: 0
              },
              OrderFileID: file.OrderFileID,
              circles: [],
              ImageType: 2,
              base64: files[index].imageUrl,
              rotation: 0
            })
          } else {
            documents.push({
              OrderFileID: file.OrderFileID,
              FileName: file.FileURL,
              name: file.FileName,
              ImageType: -1
            })
          }
        })
        this.props.updateState({
          images: images,
          files: documents
        })
        // createOrder(finishedFiles, IsEvaluation, evaluationComment)
      }, () => {
        this.props.setErrors({
          isLoading: false
        })
        // Toastr
        window.toastr.error(translation('13440'), translation('216'))
      })
    })
  }

  onDropRejected (files) {
    let newErrors = files.map(file => 'File: ' + file.name + ' is not allowed.')
    this.setState({ upload: { ...this.state.upload, errors: newErrors } })
  }

  renderFiles () {
    let files = this.props.files

    const removeFile = (index) => {
      let oldFiles = this.props.files
      let newFiles = [...oldFiles].filter((item, i) => {
        return i !== index
      })

      this.props.updateState({
        files: newFiles
      })
    }

    const renderFile = (file, index) => {
      if (file.file === null) return null
      let thumbUrl = API_URL + '/FileService/GetIcon?fileName=' + file.name

      // let newFileUrl = API_URL + '/FileService/DownloadNoHeader?fileName=' + file.ActualFileName + '&token=' + this.props.auth.user.Token
      // let thumbUrl = API_URL + '/FileService/DownloadNoHeader?fileName=' + file.ThumbURL + '&token=' + this.props.auth.user.Token
      return (
        <div key={index} className='file-document clearfix'>
          <img className='file-icon' alt='icon' src={thumbUrl} />
          <span>{file.name}</span>
          {this.props.auth.user.CustomerId === '-1' && <img className='file-delete' src='/images/icons/Delete_16.png' onClick={() => removeFile(index)} />}
        </div>
      )
    }

    return (
      <div className='estimation_documents'>
        {files.map(renderFile)}
      </div>
    )
  }

  deleteImage (image, index) {
    this.setState({
      confirm: index
    })
  }

  renderImages () {
    let { images } = this.props
    // Render image
    const renderImage = (image, index) => {
      return (
        <div key={index}>
          <div className='delete'><RemoveButton onClick={() => this.deleteImage(image, index)} size='s' /></div>
          <img src={image.base64} onClick={() => this.goToImage(image, index)} />
        </div>
      )
    }
    // Confirm
    const onPortalClose = () => {
      this.setState({
        confirm: false
      })
    }
    const onConfirm = () => {
      let images = [...this.props.images]
      images.splice(this.state.confirm, 1)

      this.props.updateState({ images: images })
      this.setState({ confirm: false })
    }
    // Return
    return (
      <div className='estimation_images'>
        <Gallery files={images} renderImage={renderImage} />
        {this.state.confirm !== false && (
          <Portal className='deleteModal' onPortalClose={onPortalClose}>
            <Confirm confirm={onConfirm} notConfirm={onPortalClose} />
          </Portal>
        )}
      </div>
    )
  }

  goToImage (image, index) {
    this.props.updateState({
      activeImage: {
        image: image,
        index: index
      }
    }, () => {
      this.props.updateModal({
        tabView: 'image'
      })
    })
  }

  renderError (error, key) {
    return <p key={key}>{error}</p>
  }

  render () {
    let { errors } = this.state.upload

    return (
      <div className='clearfix'>
        {errors.length !== 0 && <div className='alert alert-danger'>{errors.map(this.renderError)}</div>}
        <Dropzone
          onDrop={this.onDrop}
          onDropAccepted={this.onDropAccepted}
          onDropRejected={this.onDropRejected}
          includeCircles>
          <p>{translation('13397')}</p>
        </Dropzone>
        {this.renderFiles()}
        {this.renderImages()}
      </div>
    )
  }
}

FileArea.propTypes = {
  files: PropTypes.array.isRequired,
  images: PropTypes.array.isRequired,
  updateState: PropTypes.func.isRequired,
  updateModal: PropTypes.func.isRequired,
  setErrors: PropTypes.func.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  createFileContainer,
  uploadMultipleFiles,
  uploadImageMarkings
})(FileArea)



// WEBPACK FOOTER //
// ./src/app/shared/modals/NewOrdersModal/FileArea/index.js